import { FormGroup } from '@angular/forms';

export function confirmPassword(passwordControlName: string, confirmPasswordControlName: string) {
    return (group: FormGroup) => {
        const passwordControl = group.controls[passwordControlName];
        const confirmPasswordControl = group.controls[confirmPasswordControlName];

        if (!passwordControl || !confirmPasswordControl) {
            return;
        }

        if ((passwordControl.value || '') !== (confirmPasswordControl.value || '')) {
            return confirmPasswordControl.setErrors({ nomatch: true });
        }

        return confirmPasswordControl.setErrors(null);
    };
}
